import type { ApiTaskStatus } from "../data/api/types";

/**
 * How many children a parent in Review is waiting on — the "Waiting on N
 * agents" its card and header show in place of reading as your move
 * (task-messages.md §On the board). Zero outside Review, where the column
 * already says what is happening, and from a server that predates the count.
 */
export const waitingOnAgents = (
  status: ApiTaskStatus,
  count: number | undefined,
): number => (status === "review" ? (count ?? 0) : 0);

/** The cue's words: "Waiting on 1 agent", "Waiting on 3 agents". */
export const waitingOnAgentsLabel = (count: number): string =>
  `Waiting on ${count.toString()} ${count === 1 ? "agent" : "agents"}`;
